import { render } from "./ResetCardConfirmPopup.vue?vue&type=template&id=b4fd7ed8&scoped=true"
import script from "./ResetCardConfirmPopup.vue?vue&type=script&lang=js"
export * from "./ResetCardConfirmPopup.vue?vue&type=script&lang=js"

import "./ResetCardConfirmPopup.vue?vue&type=style&index=0&id=b4fd7ed8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fd7ed8"]])

export default __exports__